import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { GasTable } from './gas-table.namespace';

// Сервис не является singleton, хостится по одному экземпляру на каждую таблицу
@Injectable()
export class GasTableService {

  public changeSortingSubject = new Subject<GasTable.SortingValue>();

  // указан unknown т.к. этот Observable служит как сигнал без передаваемого внутрь значения
  public selectionSource$: Observable<unknown>;
  public selectionTableRepositorySource$: Observable<GasTable.SortingValue>;

  private selectionSource = new Subject();
  private selectionTableRepositorySource = new BehaviorSubject<GasTable.SortingValue>(undefined);

  constructor() {
    this.selectionSource$ = this.selectionSource.asObservable();
    this.selectionTableRepositorySource$ = this.selectionTableRepositorySource.asObservable();
  }

  public onSelectionChange(): void {
    this.selectionSource.next();
  }

  public sortingTableRepository(sorting: GasTable.SortingValue): void {
    this.selectionTableRepositorySource.next(sorting);
  }
}
